import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import {Tabs, Tab} from 'material-ui/Tabs';
import EditUsersRolesForm from './editUsersRolesForm';


@inject('translationsStore', 'addEditUserStore') @observer
export default class EditUsersRolesTabs extends Component {

    state = {
        selectedTabId: -1
    };

    
    handleActive = (tab) => this.setState({selectedTabId: tab.props.value});
    
    componentDidMount() {
        this.setState({selectedTabId: 1});
    }

    render() {

        const tabStyleProps = {
            className: `tab-dialog`,
            buttonStyle: { color: '#372f51' },
            style: {backgroundColor: '#fff'}
        };

        const editTypes = {
            ADD : 'add',
            REMOVE : 'remove'
        };


        const tabs = [
            {
                id: 1,
                title: 'Add Roles',
                component: <EditUsersRolesForm edit={editTypes.ADD}/>,
                dataCy: 'edit-users-roles-add'
            },
            {
                id: 2,
                title: 'Remove Roles',
                component: <EditUsersRolesForm edit={editTypes.REMOVE} />,
                dataCy: 'edit-users-roles-remove'
            } 
        ];

        return (
                <div style={{position: 'relative'}}>
                    <Tabs className='tabs-dialog' contentContainerClassName='tabs-dialog-content-wrapper'>
                        {
                            tabs.map((tab, index) => {

                                var selectedClass = this.state.selectedTabId == tab.id ? ' selected' : '';

                                return <Tab key={index} 
                                            {...tabStyleProps} 
                                            value={tab.id}
                                            className={`tab-dialog${selectedClass}`}
                                            style={{backgroundColor: '#fff'}} 
                                            label={tab.title}
                                            onActive={this.handleActive}
                                            data-cy={tab.dataCy}>
                                            <div>
                                                {tab.component}
                                            </div>
                                        </Tab>;
                            })
                        }
                    </Tabs>
                </div>
        );
    }
}